
  import ipxRuntime$jVcUFCzVGvAbMwiLVZMsSI0elvl0Y0VYJ4Og2WPf3W0 from '/app/node_modules/.pnpm/@nuxt+image@2.0.0_db0@0.3.4_ioredis@5.9.1_magicast@0.5.1/node_modules/@nuxt/image/dist/runtime/providers/ipx'
  
  export const imageOptions = {
    ...{
  "screens": {
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
},
    /** @type {"ipx"} */
    provider: "ipx",
    providers: {
        ['ipx']: { setup: ipxRuntime$jVcUFCzVGvAbMwiLVZMsSI0elvl0Y0VYJ4Og2WPf3W0, defaults: {"maxAge":3600} }
    }
  }
